export class SettingsConstants {
  public static get confirmationTitle(): string {
    return '<b>Discard changes?</b>';
  }

  public static get confirmationText(): string {
    return 'There are unsaved changes on this page. To save your' +
      ' work click the "Cancel" button to return to the settings page.';
  }

  public static get confirmationButtonText(): string {
    return 'Discard Changes';
  }

  public static get settingsUpdateSuccess(): string {
    return 'Settings successfully updated';
  }
}
